import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { SetupActivity } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'

export default class SetupActivityModal extends Component {
  static propTypes = {
    activity: PropTypes.object,
    modalId: PropTypes.string,
  }

  render() {
    const { activity, modalId } = this.props

    const colorClass = getActivityClassName(get(activity, 'activitySection.value'))

    return (
      <MaterialModal.Body
        id={modalId}
        colorClass={colorClass}
        title='New Activity'
        titleKey='moduleTitle.new_activity'
        noEscape
      >
        <MaterialModal.Content>
          <SetupActivity {...this.props} colorClass={colorClass} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
